.card {
    min-width: 0;
    width: 100%;
    margin: 0;
}

.cardTitle {
    font-size: 14px;
    overflow-wrap: anywhere;
}

.key {
    background-color: dimgrey;
    font-weight: bold;
    letter-spacing: .09rem;
    color: rgb(8, 8, 8);
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    vertical-align: middle;
}
